export default {
  no_results: {
    title: 'Sin resultados para «{{search}}»',
    desc: 'Lo sentimos, no encontramos coincidencias. Prueba con otro término de búsqueda.',
  },
  empty_menu: {
    title: 'Aún no hay artículos disponibles',
    desc: 'Este menú no tiene nada que mostrar ahora mismo. Vuelve pronto.',
  },
};
